import { useEffect, useState } from "react";

/**
 * Services
 */
import { storageGalery } from "services/storage";

/**
 * Components
 */
import Header from "components/Header";
import Footer from "components/Footer";

/**
 * Crée la vue de la page blog.
 * @returns La page blog.
 */
function Blog() {
    const [galery, setGalery] = useState(storageGalery);
    const [tags, setTags] = useState(null);

    /**
     * Rassemble tous les tags possibles dans un tableau et suppriment les doubles.
     */
    useEffect(() => {
        const newArray = [];

        storageGalery.forEach(element => {
            element.tags.forEach(tag => {
                if (!newArray.includes(tag)) {
                    newArray.push(tag);
                }
            })
        });

        setTags(newArray);
    }, [])

    /**
     * Filtre les images de la galerie.
     * @param {Object} e 
     */
    function filter(e) {
        let choice = e.target.value;
        let newArray = [];
        
        if (choice === "all") {
            newArray = storageGalery;
        } else {
            storageGalery.forEach(element => {
                element.tags.forEach(tag => {
                    if (choice === tag.toLowerCase()) {
                        newArray.push(element);
                    }
                })
            });
        }

        setGalery(newArray);
    }

    return (
        <div className="blog">
            <Header />
            <main>
                <select onChange={(e) => filter(e)} name="blog-search" id="blog-search-select">
                    <option value="all">tout</option>
                    {
                        tags !== null ?
                        tags.map((tag, index) => (
                            <option key={index} value={tag}>{ tag }</option>
                        )) :
                        null
                    }
                </select>

                <section className="blog-galery">
                    {
                        galery.map((element, index) => (
                            <div key={index} className="blog-galery-element">
                                <img src={element.image.src} alt={element.image.alt} />
                            </div>
                        ))
                    }
                </section>
            </main>
            <Footer />
        </div>
    )
}

export default Blog;